import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css"; // Import dei font Google esistenti


export const everestTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT - Temi naturali e organici
            typography: {
                fontFamily: ['"Inter"', 'system-ui', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
                h1: { fontWeight: 700, letterSpacing: '-0.02em' },
                button: { letterSpacing: '0.01em' },
            },

            // CONFIGURAZIONE PALETTE - Colori naturali
            palette: {
                mode: 'light',
                primary: { main: '#4A3A2C', light: '#6B5646', dark: '#33261C', contrastText: '#FFFFFF' },
                secondary:{ main: '#C7A144', light: '#D7B86B', dark: '#8E752F', contrastText: '#1E1B16' },
                success:  { main: '#2E7D6F', light: '#58A193', dark: '#1F5A4F', contrastText: '#FFFFFF' },
                info:     { main: '#2A6F8F', light: '#5A97B1', dark: '#1D4E65', contrastText: '#FFFFFF' },
                warning:  { main: '#B8741A', light: '#D1964D', dark: '#7F4F10', contrastText: '#1E1B16' },
                error:    { main: '#9C2F2F', light: '#BF5454', dark: '#6E2020', contrastText: '#FFFFFF' },
                background: { default: '#F3E7D3', paper: '#F8F1E6' },
                text: { primary: '#2B2A28', secondary: '#5E5A56', disabled: '#8D877E' },
                divider: '#E0D6C6',
            },

            // CONFIGURAZIONE FORME - Morbide e organiche
            shape: {
                borderRadius: 12, // Bordi morbidi
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON con stile naturale
                MuiButton: {
                    styleOverrides: {
                        root: { borderRadius: 12, textTransform: 'none', fontWeight: 600 },
                        containedPrimary: {
                            boxShadow: 'none',
                            ':hover': { backgroundColor: '#3C2E23' }, // leggermente più scuro
                        },
                        outlined: { borderColor: '#C7A144', ':hover': { borderColor: '#8E752F' } },
                    },
                },

                // CARD con ombre naturali
                MuiCard: { styleOverrides: { root: { borderRadius: 16, boxShadow: '0 6px 20px rgba(51,38,28,0.12)' } } },
                MuiAppBar:{ styleOverrides:{ colorPrimary:{ backgroundColor:'#4A3A2C' } } },

                // TEXTFIELD organici
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 12,
                                "& fieldset": {
                                    borderColor: "rgba(143, 188, 143, 0.5)",
                                },
                                "&:hover fieldset": {
                                    borderColor: "rgba(143, 188, 143, 0.8)",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#8FBC8F",
                                },
                            },
                        },
                    },
                },

                // CHIP naturali
                MuiChip: {
                    styleOverrides: {
                        root: {
                            borderRadius: 20,
                        },
                    },
                },
            },









            // COLORI CUSTOM per il tema naturale
            andonStatoPagamento: {
                inLavorazione: "#DAA520", // Goldenrod
                daRichiedere: "#4682B4", // Steel Blue
                inAttesaPagamento: "#DEB887", // Burlywood
                parzialmentePagato: "#C8E6C9", // Light Green
                pagato: "#228B22", // Forest Green
                annullato: "#A9A9A9", // Dark Gray
            },
            coloriFiltro: {
                attivo: "#8FBC8F", // Dark Sea Green
                disattivo: "#F5E6D3", // Beige chiaro
            },
        },
        itIT
    )
);